import { Routes } from "@angular/router";

import { usersListRoutes, usersRoutes } from "./nested-features/users";
import { companiesListRoutes, companiesManagementRoutes } from "./nested-features/companies";
import { officialInstitutionsListRoutes, officialInstitutionsRoutes } from "./nested-features/official-institutions";

export const usersManagementRoutes: Routes = [
  {
    path: "",
    title: "USERS.USERS_MANAGEMENT",
    data: {
      tabs: [
        {
          key: "Users",
          title: "USERS.TITLE",
          routerLink: "users",
        },
        {
          key: "Visitors",
          title: "EVENTS.VISITORS",
          routerLink: "clients",
        },
        {
          key: "Memberships",
          title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP",
          routerLink: "memberships",
        },
        // {
        //   key: "OrganizedSchools",
        //   title: "USERS.ORGANIZED_SCHOOLS",
        //   routerLink: "organized-schools",
        // },
        {
          key: "OfficialInstitutions",
          title: "OFFICIAL_INSTITUTIONS.TITLE",
          routerLink: "official-institutions",
        },
        {
          key: "Companies",
          title: "COMPANIES.TITLE",
          routerLink: "tourism-companies",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      { path: "", redirectTo: "users", pathMatch: "full" },
      {
        path: "users",
        children: usersListRoutes,
      },
      {
        path: "clients",
        children: usersListRoutes,
      },
      {
        path: "memberships",
        children: usersListRoutes,
      },
      // {
      //   path: "organized-schools",
      //   children: usersListRoutes,
      // },
      {
        path: "official-institutions",
        children: officialInstitutionsListRoutes,
      },
      {
        path: "tourism-companies",
        children: companiesListRoutes,
      },
    ],
  },
  {
    path: "users",
    children: usersRoutes,
  },
  {
    path: "clients",
    children: usersRoutes,
  },
  {
    path: "memberships",
    children: usersRoutes,
  },
  {
    path: "organized-schools",
    children: usersRoutes,
  },
  {
    path: "official-institutions",
    children: officialInstitutionsRoutes,
  },
  {
    path: "tourism-companies",
    children: companiesManagementRoutes,
  },
];
